import { EntityCollectionValue } from "models/list-user-entity-collection-value";
import { doDelete, doGet, doPatch, doPost } from "../request";
import { EntityCollection } from "models/list-user-entity-collection";

// NOTE: this one by default returns nested EntityCollectionValues
export const userDoGetEntityCollections = async (entityUuid: string) => {
  const entityCollections = await doGet<EntityCollection[]>(
    `/user/entity/${entityUuid}/collections`,
  );
  return entityCollections;
};

export const userDoPostEntityCollection = async (
  entityUuid: string,
  entityCollectionValues: Partial<EntityCollectionValue>[],
) => {
  const ec = await doPost<EntityCollection>(
    `/user/entity/${entityUuid}/collection`,
    { entityCollectionValues },
  );
  return ec;
};

export const userDoPatchEntityCollection = async (
  entityUuid: string,
  collectionUuid: string,
  entityCollection: Partial<EntityCollection>,
) => {
  await doPatch(
    `/user/entity/${entityUuid}/collection/${collectionUuid}`,
    entityCollection,
  );
};

export const userDoDeleteEntityCollection = async (
  entityUuid: string,
  collectionUuid: string,
) => {
  await doDelete(`/user/entity/${entityUuid}/collection/${collectionUuid}`);
};
